export default __webpack_public_path__ + "static/media/coloquio_BannerWeb_4.b63bab16.jpg";